/* Publish by EComposer at 2026-10-15 13:09:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nlnbcyxv33h"]=  window.__ectimmers["ecom-nlnbcyxv33h"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nlnbcyxv33h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nlnbcyxv33h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vp1m9zjwwlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vp1m9zjwwlk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aysvgnti62t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aysvgnti62t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phl99wy4r9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phl99wy4r9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifdtz4l8cn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifdtz4l8cn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4i9klkogkyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4i9klkogkyr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fo7ywci5or').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fo7ywci5or', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d5w38uol1xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5w38uol1xp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iywk0105fqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iywk0105fqp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l236xjiyxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l236xjiyxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-917p853thb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-917p853thb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9uzvg38m3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9uzvg38m3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-on5b3676sib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-on5b3676sib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-90o9qmohlzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-90o9qmohlzf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l26w1rspx2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l26w1rspx2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-prrzyiimx4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-prrzyiimx4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2k3eni3wdv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2k3eni3wdv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqy084j0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqy084j0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cx2zl6offf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cx2zl6offf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4yhcnpy5eqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4yhcnpy5eqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w55xug37gxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w55xug37gxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpdl5n65ujr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpdl5n65ujr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18eszly0e2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18eszly0e2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7j3i06kohxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7j3i06kohxc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nd769frnnmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nd769frnnmf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nosp4f5tnaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nosp4f5tnaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjob3iwqye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjob3iwqye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nttdhgikhya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nttdhgikhya', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s305n3a3q1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s305n3a3q1e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfbf4r3cjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfbf4r3cjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e464cmxyn2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e464cmxyn2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf0ylf1kkqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf0ylf1kkqq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mjzdaxk77cd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mjzdaxk77cd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acx2910sks6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acx2910sks6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fib198kiy4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fib198kiy4u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10h9mr2um16n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10h9mr2um16n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p55fbu75q9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p55fbu75q9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73dxhedjhkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73dxhedjhkp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vzmx0wszuy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzmx0wszuy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkokacvhidq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkokacvhidq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9y5la3d02iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9y5la3d02iq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eb41upnqrdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eb41upnqrdd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tle9aadf68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tle9aadf68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4j837i6cjea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4j837i6cjea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kmo2fxkmpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kmo2fxkmpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6k7uqe2wq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6k7uqe2wq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-56u43qb8oa5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-56u43qb8oa5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwqv5zzyt4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwqv5zzyt4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z95mpvbh2vq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z95mpvbh2vq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fqjhxcquuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fqjhxcquuc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nowt5j6677e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nowt5j6677e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1f4nzfnyp2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1f4nzfnyp2i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8pnteu1dyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8pnteu1dyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o89cnkj8e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o89cnkj8e4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqvrbnl2o1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqvrbnl2o1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lz8dbdw8drk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lz8dbdw8drk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1hd6pq78fai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1hd6pq78fai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmettc1wyw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmettc1wyw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r43vvsqbuwe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r43vvsqbuwe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xoyprvmbv9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xoyprvmbv9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2959q4oq8ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2959q4oq8ao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95zak560pk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95zak560pk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwg20lo1b4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwg20lo1b4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ag9mwc843yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ag9mwc843yn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnit42v3xmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnit42v3xmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0gb8p4g1rzsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gb8p4g1rzsj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dz6w1qw828e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dz6w1qw828e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4i05b18gb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4i05b18gb9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exphbq8pw7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exphbq8pw7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tplnrm8hdw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tplnrm8hdw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4pg2utueh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4pg2utueh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wr50lk7fc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wr50lk7fc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mv4jt61one').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mv4jt61one', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xejpt29nkhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xejpt29nkhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ob706m24ec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ob706m24ec', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgu5kj48k9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgu5kj48k9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxina2gior').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxina2gior', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fnmj6zdefx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fnmj6zdefx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-183h3j49wpz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-183h3j49wpz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s37o84uwi5a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s37o84uwi5a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvorc66zjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvorc66zjf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iplwyx17w1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iplwyx17w1a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t6v8msekzz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t6v8msekzz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r82znyzqlwi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r82znyzqlwi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oky5uv7uzw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oky5uv7uzw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-789mbq05dd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-789mbq05dd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmshyod4mon').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmshyod4mon', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfy4hj8xi2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfy4hj8xi2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fii4xb4gcx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fii4xb4gcx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k513sii1erl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k513sii1erl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2155uwbx1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2155uwbx1m', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kdnl7j8x7k"]=  window.__ectimmers["ecom-kdnl7j8x7k"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-kdnl7j8x7k"]["318iebb65"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-kdnl7j8x7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdnl7j8x7k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1fgm8ln3rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1fgm8ln3rq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-de79p3jl4lj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-de79p3jl4lj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fcohzr1z5va').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fcohzr1z5va', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18t1vj7jo1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18t1vj7jo1k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqcx9c2v81u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqcx9c2v81u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ie5cq684w2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ie5cq684w2r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkl7zrrjdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkl7zrrjdc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fpue5z32sl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fpue5z32sl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0ywwuprnx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0ywwuprnx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa37gpfncd7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa37gpfncd7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tohcc73qgtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tohcc73qgtq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1tick30492t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tick30492t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3adyr8vrxaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3adyr8vrxaw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqesspkx1tc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqesspkx1tc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5nce3saxe7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5nce3saxe7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kwq36ebogm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kwq36ebogm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgblcr4popf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgblcr4popf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dkrv6uep48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dkrv6uep48', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbdx8mxsvz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbdx8mxsvz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lzhvdmo7t6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lzhvdmo7t6h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csada1eo4qt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csada1eo4qt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ydbt98qc6ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ydbt98qc6ue', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvnrq20y2p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvnrq20y2p9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lt290g8qspg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lt290g8qspg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-trjgrx9kmaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-trjgrx9kmaa', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g7snaaybkw"]=  window.__ectimmers["ecom-g7snaaybkw"] || {};
var $,E,A,j,P,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,n=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(I=>I.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(I){const D=I.getBoundingClientRect();return D.top>=0&&D.left>=0&&D.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&D.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(I){return o&&I<768||s&&I>767&&I<1025||i&&I>1024}function b(I){if(!I)return;const D=I.style.transition;I.style.transition="none",I.style.height="auto";const R=I.scrollHeight;I.style.height="0px",I.offsetHeight,I.style.transition=D,requestAnimationFrame(()=>{const H=r?"auto":e?R+"px":"auto";I.style.height=H})}function y(I){I.classList.remove("ecom-item-active");const D=I.querySelector(":scope > .ecom-accordion__body");D&&(r||(D.style.height=D.scrollHeight+"px",D.offsetHeight),requestAnimationFrame(()=>{D.style.height="0px"}))}function v(I){let D=0;if(I.offsetParent)do D+=I.offsetTop;while(I=I.offsetParent);return D}function w(I){const D=Math.max(0,I),R=window.pageYOffset||document.documentElement.scrollTop,H=D-R;if(H===0)return;const K=300;let V=null;function G(te){V||(V=te);const ne=Math.min((te-V)/K,1),Y=ne<.5?2*ne*ne:1-Math.pow(-2*ne+2,2)/2;window.scrollTo(0,R+H*Y),ne<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function z(I){w(v(I)-100)}function C(I,D=!1){I.forEach((R,H)=>{const K=R.parentNode,V=K.querySelector(":scope > .ecom-accordion__body");!r&&V&&V.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");V&&!a&&(D&&H===0||G)&&requestAnimationFrame(()=>{V.style.height=V.scrollHeight+"px"}),R.onclick=function(te){var pe,_e;if(te.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const ne=m(),Y=this.parentNode,he=Y.parentNode,ce=he.querySelectorAll(":scope > .ecom-accordion__item"),ue=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),X=_(ne);if(U)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),ue.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),ue.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),R.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(pe=we.parentElement)==null?void 0:pe.closest)==null?void 0:_e.call(pe,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const ee=this,ge=n||ne>1024;function Q(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(ee)&&z(ee)}if(ge&&!r){let we;const Ae=function(Te){Te.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},50))};he.addEventListener("transitionend",Ae),setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},600)}else requestAnimationFrame(()=>{setTimeout(Q,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const I=t.querySelector(".ecom-item-group-init");I&&I.classList.remove("ecom-item-group-init")});function S(){const I=window.location.hash;if(I){const D=t.querySelector(`[data-target="${I}"]`);if(D){D.click(),D.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=D.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(S,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",S,!1)

                    });
                    
                        document.querySelectorAll('.ecom-g7snaaybkw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7snaaybkw', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zeuuiztuchq"]=  window.__ectimmers["ecom-zeuuiztuchq"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-zeuuiztuchq"]["6a633lnaq"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-zeuuiztuchq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zeuuiztuchq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aefb31moepq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aefb31moepq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3uibowdld8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3uibowdld8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcaob0s411').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcaob0s411', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nxw53jdnv7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nxw53jdnv7e', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ack7cpluxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ack7cpluxm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w40ciuwl7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w40ciuwl7p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfqaseynf3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfqaseynf3h', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4ukzvcekbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4ukzvcekbi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7siece86e7w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7siece86e7w', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vxad4zcezw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vxad4zcezw', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2kf1v2dxke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2kf1v2dxke', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4n0fppjzfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4n0fppjzfc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1abeind8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1abeind8n', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}